export const KEY_WORDS = [
  'nossa vaquinha',
  'vaquinha',
  'campanha',
  'arrecadação',
  'arrecadacao',
  'vaquinha online'
];
